import { Factory } from '../Factory';
import { IAccount } from '../../model/account/IAccount';

namespace app.services.account {

  export class AccountService implements IService {
    private ItemResource;
    private account: IAccount;

    constructor(private rootScope: IRootScope, $cookies, private $http: angular.IHttpService, private httpService: app.services.IHttpWrapperService, private configService: app.services.IConfigService, private tokenService: app.services.authentication.TokenService, private notificationService: app.services.INotificationService) {
      this.account = {
        id: "",
        subdomain: "",
        email: "",
        firstName: "",
        lastName: "",
        currentProjectRoleId: "",
        projectRole: null,
        image: null,
        role: []
      };
    }

    public Fetch() {
      const data = {
        access_token: this.tokenService.GetAccessToken(),
        client_id: this.configService.getClientId()
      };

      console.log("AccountService.Fetch with: ", data);

      return this.$http.get(`${this.configService.getServerBaseUrl()}/account/current`, {params: data})
        .success((data: IAccount) => data && this.SetAccount(data))
        .error(data => console.error(data));
    };

    public async FindByProject(project) {
      const response = await this.httpService.$http({
        method: "GET",
        url: `${this.configService.getServerBaseUrl()}/account/project/${project.id}/false`
      });

      return response.data;
    };

    public RegisterMFA(callback, errorCallback) {
      this.httpService.$http({
        method: "POST",
        url: `${this.configService.getServerBaseUrl()}/account/mfa/register`
      }).success(response => {
        if (response) {
          this.SetAccount(response);
          this.notificationService.addSuccess({
            title: "Multi Factor Authentication Enabled for Account",
            timeout: 2500
          });
        }
        if (callback) callback(response);
      }).error(response => {
        this.notificationService.addError({
          title: "Error enabling Multi Factor Authentication for Account",
          description: "That's embarrassing, please try again later",
          timeout: 5000
        });

        if (errorCallback) errorCallback(response.data);
      });
    }

    public RegisterMFAForLogin(email: string, token: string, phone: string, callback, errorCallback) {
      this.httpService.$http({
        method: "POST",
        url: `${this.configService.getServerBaseUrl()}/account/login/mfa/register/email/${email}/token/${token}/phone/${phone}`
      }).success(response => {
        if (callback) callback(response);
      }).error(response => {
        this.notificationService.addError({
          title: "Error Request MFA Verification Code",
          description: "That's embarrassing, please try again later",
          timeout: 5000
        });

        if (errorCallback) errorCallback(response.data);
      });
    }

    public VerifyMFAForLogin(email: string, password, token: string, code: string, callback, errorCallback) {
      this.tokenService.VerifyMFA(email, password, token, code).success(response => {
        if (callback) callback(response);
      }).error(response => {
        this.notificationService.addError({
          title: "Error Request MFA Verification Code",
          description: "That's embarrassing, please try again later",
          timeout: 5000
        });

        if (errorCallback) errorCallback(response.data);
      });
    }

    public StartMFA(callback?: Function, errorCallback?: Function) {
      this.httpService.$http({
        method: "POST",
        url: `${this.configService.getServerBaseUrl()}/account/mfa/start`
      }).success(response => callback && callback(response))
        .error(response => errorCallback && errorCallback(response.data));
    }

    public Update(account, callback, errorCallback) {
      return this.httpService.$http({
        method: "PUT",
        url: `${this.configService.getServerBaseUrl()}/account/current`,
        data: _.pick(account, "firstName", "lastName", "phone")
      }).success(response => {
        if (response) {
          this.SetAccount(response);
          this.notificationService.addSuccess({
            title: "Account Updated",
            timeout: 2500
          });
        }

        if (callback) callback(response);
      }).error(data => {
        this.notificationService.addError({
          title: "Error updating Account",
          description: "That;s embarrassing, please try again later",
          timeout: 5000
        });

        if (errorCallback) errorCallback(data);
      });
    }

    public RemoveFromProject(project, account, role, callback, errorCallback) {
      return this.httpService.$http({
        method: "DELETE",
        url: `${this.configService.getServerBaseUrl()}/account/${account.id}/project/${project.id}`,
        data: {role: role}
      }).success(response => {
        if (response) {
          this.notificationService.addSuccess({
            title: "Account Removed",
            description: `${account.fullName} removed from ${project.name}`,
            timeout: 2500
          });
        }
        if (callback) callback(response);

      }).error(data => {
        this.notificationService.addError({
          title: "Error removing Account",
          description: "That's embarrassing, please try again later",
          timeout: 5000
        });

        if (errorCallback) errorCallback(data);
      });
    }

    public UpdateRoleForProject(project, account, role, callback, errorCallback) {
      return this.httpService.$http({
        method: "PUT",
        url: `${this.configService.getServerBaseUrl()}/account/${account.id}/project/${project.id}/role/${role.id}`
      }).success(response => {
        if (response) {
          this.notificationService.addSuccess({
            title: "Account Role Updated",
            description: `${account.fullName} is now ${role.name}`,
            timeout: 2500
          });
        }

        if (callback) callback(response);
      }).error(data => {
        this.notificationService.addError({
          title: "Error updating Account role",
          description: "That's embarrassing, please try again later",
          timeout: 5000
        });

        if (errorCallback) errorCallback(data);
      });
    }

    public Get() {
      return this.account;
    }

    public GetEmail() {
      return this.account.email;
    }

    public GetFirstName() {
      return this.account.firstName;
    }

    public GetFullName() {
      return `${this.account.firstName}  ${this.account.lastName}`;
    }

    public GetRoles() {
      return this.account.role;
    }

    public GetImageBadge() {
      return this.account.image.badge;
    }

    public GetImageSmall() {
      return this.account.image.small;
    }

    public IsSuperAdmin() {
      return _.contains(this.account.role, "ROLE_ADMIN");
    }

    public SetAccount(account: IAccount) {
      this.account = account;
      this.rootScope.$broadcast("AccountService.accountUpdated", account);
    }
  }

  frontendApp.factory("AccountService", ["$rootScope", "$cookies", "$http", "HttpService", "ConfigService", "TokenService", "NotificationService", Factory.Create(AccountService)]);
}
